<script>
  import { onMount } from 'svelte';
	import { Styles, Card,CardBody,
    CardFooter,
    CardHeader,
    CardSubtitle,
    CardText,
    CardTitle } from 'sveltestrap';
	import { api_url } from "./ConfigService.js";
	import Loading from "./components/Loading.svelte";
	import { Button, Textfield } from 'svelte-mui/src';
	import Login from "./pages/Login.svelte";
	import Home from "./pages/Home.svelte";

	export let data=false;

 	onMount(async () => {
		const response = await fetch($api_url+'');
		data=await response.json();
 	});
</script>

<Styles />

<main>
	{#if !data}
		<Loading />
	{:else if data.logged}
		<Home bind:data />
	{:else if typeof data.logged !== 'undefined'}
		<Login bind:data />
	{:else}
		<Loading />
	{/if}
</main>

<style>

</style>
